/**
 * @desc 导入受益部门
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/revenueDepartment/importRevenueDepartment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
